/* eslint-disable no-useless-constructor */
import feathersClient, { makeServicePlugin, BaseModel } from '../../api'

class CarChat extends BaseModel {
  constructor (data, options) {
    super(data, options)
  }

  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'CarChat'
  // Define default properties here
  static instanceDefaults () {
    return {
    }
  }

  static setupInstance (data, { models }) {
    if (data.messages) {
      data.messages = data.messages.map(message => new models.api.CarChatMessage(message))
    }
    return data
  }
}
const servicePath = 'car-chat'
const servicePlugin = makeServicePlugin({
  Model: CarChat,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
